import { render } from "./RootActions.vue?vue&type=template&id=73bea7e2"
import script from "./RootActions.vue?vue&type=script&lang=js"
export * from "./RootActions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__